import { Component } from 'solid-js';

const petals = (idPrefix: string) => (
    <>
        <radialGradient id={`${idPrefix}-petalA`} cx="35%" cy="30%" r="75%">
            <stop offset="0%" stop-color="#f1e9f2"/>
            <stop offset="100%" stop-color="#c3aecb"/>
        </radialGradient>
        <radialGradient id={`${idPrefix}-petalB`} cx="35%" cy="30%" r="75%">
            <stop offset="0%" stop-color="#e2d2e6"/>
            <stop offset="100%" stop-color="#a68bb2"/>
        </radialGradient>
        <radialGradient id={`${idPrefix}-petalC`} cx="35%" cy="30%" r="75%">
            <stop offset="0%" stop-color="#faf6fa"/>
            <stop offset="100%" stop-color="#d7c6dd"/>
        </radialGradient>
        <linearGradient id={`${idPrefix}-leaf`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#c9d3c2"/>
            <stop offset="100%" stop-color="#93a68c"/>
        </linearGradient>
    </>
);

const blossom = (fillId: string) => (
    <>
        <g fill={`url(#${fillId})`}>
            <ellipse cx="0" cy="-9" rx="6" ry="9"/>
            <ellipse cx="8.5" cy="-2.8" rx="6" ry="9" transform="rotate(72 8.5 -2.8)"/>
            <ellipse cx="5.3" cy="7.3" rx="6" ry="9" transform="rotate(144 5.3 7.3)"/>
            <ellipse cx="-5.3" cy="7.3" rx="6" ry="9" transform="rotate(216 -5.3 7.3)"/>
            <ellipse cx="-8.5" cy="-2.8" rx="6" ry="9" transform="rotate(288 -8.5 -2.8)"/>
        </g>
        <circle r="2.6" fill="#e8d9a8"/>
    </>
);

// Corner cluster of lavender hydrangea-style blossoms with sage leaves, matching the
// printed invitation. The art is drawn for the bottom-left corner and mirrored to fill
// the other three: horizontally for the right side, vertically for the top row.
const FloralCorner: Component<{ class?: string; corner?: "tl" | "tr" | "bl" | "br" }> = (props) => {
    const corner = props.corner ?? "bl";
    const idPrefix = `fc-${corner}`;
    const flipX = corner === "tr" || corner === "br";
    const flipY = corner === "tl" || corner === "tr";
    const scaleX = flipX ? -1 : 1;
    const scaleY = flipY ? -1 : 1;

    return (
        <svg
            class={props.class}
            style={flipX || flipY ? { transform: `scale(${scaleX}, ${scaleY})` } : undefined}
            viewBox="0 0 260 260"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>{petals(idPrefix)}</defs>

            <g fill={`url(#${idPrefix}-leaf)`} opacity="0.75">
                <path d="M0 230 C40 200 90 175 150 178 C110 190 75 210 55 250 C35 235 15 232 0 230Z"/>
                <path d="M40 260 C90 220 150 200 200 210 C155 215 120 235 100 260 Z"/>
                <path d="M0 150 C30 135 60 138 78 155 C55 155 35 165 22 180 Z"/>
                <path d="M10 190 C45 175 80 178 100 195 C75 192 50 198 35 215 Z"/>
            </g>

            <g transform="translate(58,232) scale(1.6)">{blossom(`${idPrefix}-petalA`)}</g>
            <g transform="translate(78,214) scale(1.5)">{blossom(`${idPrefix}-petalB`)}</g>
            <g transform="translate(40,208) scale(1.3)">{blossom(`${idPrefix}-petalC`)}</g>
            <g transform="translate(95,245) scale(1.3)">{blossom(`${idPrefix}-petalA`)}</g>
            <g transform="translate(30,240) scale(1.1)">{blossom(`${idPrefix}-petalB`)}</g>
            <g transform="translate(65,196) scale(1.1)">{blossom(`${idPrefix}-petalC`)}</g>

            <g transform="translate(140,225) scale(1.4)">{blossom(`${idPrefix}-petalB`)}</g>
            <g transform="translate(160,240) scale(1.2)">{blossom(`${idPrefix}-petalA`)}</g>
            <g transform="translate(122,238) scale(1.0)">{blossom(`${idPrefix}-petalC`)}</g>

            <g transform="translate(20,170) scale(0.8)">{blossom(`${idPrefix}-petalC`)}</g>
            <g transform="translate(45,150) scale(0.6)">{blossom(`${idPrefix}-petalA`)}</g>
            <g transform="translate(65,130) scale(0.5)">{blossom(`${idPrefix}-petalB`)}</g>
            <g transform="translate(12,120) scale(0.45)">{blossom(`${idPrefix}-petalC`)}</g>
            <g transform="translate(190,205) scale(0.7)">{blossom(`${idPrefix}-petalA`)}</g>
            <g transform="translate(210,225) scale(0.5)">{blossom(`${idPrefix}-petalB`)}</g>

            <g fill="#d7c6dd" opacity="0.7">
                <circle cx="30" cy="105" r="2"/>
                <circle cx="8" cy="90" r="1.6"/>
                <circle cx="200" cy="190" r="2.2"/>
                <circle cx="225" cy="215" r="1.8"/>
                <circle cx="15" cy="200" r="2"/>
            </g>
        </svg>
    );
};

export default FloralCorner;
